var _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBasket = function SvgBasket(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 59.999999",
    width: 60,
    height: 60,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs365"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.7951316,0,0,1.9832611,-309.72579,-284.31347)",
    id: "g4920"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 172.8,144.2 4.7,2.5 3.5,15.3 c 0.1,0.6 0.6,1 1.2,1 h 17.1 c 0.5,0 1,-0.3 1.2,-0.8 l 4.5,-11.7 c 0.3,-0.8 -0.3,-1.7 -1.2,-1.7 H 185",
    id: "path4912",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1.95404718,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "196.7,167.9 183.7,167.9 182.3,162.9  ",
    id: "polyline4914",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1.95404718,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 184.7,
    cy: 170.2,
    r: 2.3,
    id: "circle4916",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1.95404718,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 196.7,
    cy: 170.2,
    r: 2.3,
    id: "circle4918",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1.95404718,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBasket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/basket.9ba8e3c3.svg";
export { ForwardRef as ReactComponent };